import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(header: string, textOrTpl: string | TemplateRef<any>, options: any = {}) {
    // Remove any position classes from options.classname if they exist
    if (options.classname) {
      options.classname = options.classname
        .replace(/position-fixed/g, '')
        .replace(/bottom-\d/g, '')
        .replace(/end-\d/g, '')
        .replace(/mb-\d/g, '')
        .replace(/me-\d/g, '')
        .trim();
    }

    // Set default delay of 20 seconds unless a delay is explicitly set
    if (!options.delay) {
      options.delay = 20000; // 20 seconds
      options.autohide = true;
    }

    this.toasts.push({ header, textOrTpl, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }

  showSuccess(title: string, message: string, permanent?: boolean) {
    this.show(title, message, {
      classname: 'bg-success text-light',
      delay: 20000, // 20 seconds
      autohide: !permanent
    });
  }

  showError(title: string, message: string, permanent?: boolean) {
    this.show(title, message, {
      classname: 'bg-danger text-light',
      delay: 20000, // 20 seconds
      autohide: (typeof permanent != "undefined" ? !permanent : false)
    });
  }

  showInfo(title: string, message: string, permanent?: boolean) {
    this.show(title, message, {
      classname: 'bg-white text-dark border',
      delay: 20000, // 20 seconds
      autohide: !permanent
    });
  }
}